/* MTO — desktop prev/next arrows for Dawn <slider-component> (snippets/slider-arrows-mto.liquid).
   Scrolling itself is done by Dawn's SliderComponent (global.js); this element only
   1) centres the arrows on the product image, 2) makes one click move a full visible page. */
if (!customElements.get('slider-arrows-mto')) {
  customElements.define(
    'slider-arrows-mto',
    class SliderArrowsMto extends HTMLElement {
      connectedCallback() {
        this.host = this.closest('slider-component');
        if (!this.host) return;

        this.position = this.position.bind(this);
        this.resizeObserver = new ResizeObserver(this.position);
        this.resizeObserver.observe(this.host);

        // Capture phase: runs before SliderComponent's own click handler on the button.
        this.onClickCapture = (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          const perPage = this.host.slidesPerPage;
          button.dataset.step = perPage > 1 ? perPage : 1;
        };
        this.addEventListener('click', this.onClickCapture, true);

        this.position();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onClickCapture) this.removeEventListener('click', this.onClickCapture, true);
      }

      position() {
        const slide = Array.from(this.host.querySelectorAll('[id^="Slide-"]')).find((el) => el.clientWidth > 0);
        if (!slide) return;
        const media = slide.querySelector('.card__media') || slide.querySelector('.card__inner, .media, img') || slide;
        if (media.offsetHeight <= 0) return;
        // Layout offsets (not getBoundingClientRect): unaffected by the cards' scroll-reveal transform.
        let top = 0;
        let el = media;
        while (el && el !== this.host) {
          top += el.offsetTop;
          el = el.offsetParent;
        }
        if (el !== this.host) return;
        top += media.offsetHeight / 2;
        this.style.setProperty('--slider-arrows-mto-top', `${Math.round(top)}px`);
      }
    }
  );
}
